import styled from "styled-components";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import {ThemeProvider,  Box, Drawer, Button, List, Divider, ListItem, ListItemButton, ListItemIcon, ListItemText}  from "@mui/material";
import { FontAwesomeIcon, } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faXmark, faGrip, faPlus, faPenToSquare  } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import {SearchDashboard, AddDashboard, EditDashboard, OrganizeDashboard } from "./components"
import { GeneralButtonStyled } from "./components/generalStyles";


//configure anything related to the restaurant in here

function RestaurantsDashboard({}) {

    {/* ALL THE CONSTANTS GO HERE */}
    let {name: restaurantName, section} = useParams();
    const [template, setTemplate] = useState('');
    const location = useLocation();
    const navigate = useNavigate();
    var from;
    if(restaurantName == 'le-bleu') {
        restaurantName = "testMenus";
    }
   
    const baseURL = process.env.NODE_ENV == "development" ? process.env.REACT_APP_API_URL_DEV : process.env.REACT_APP_API_URL_PROD;
    const url = baseURL + `/${restaurantName}`
    //const [grabbedItems, setGrabbedItems] = useState([]); //add separately search, edit and organize tabs
    //const [item, setItem] = useState({}); //add separately to add, edit and organze tabs
    const [activeDashboard, setActiveDashboard] = useState("Search");
    const [triggerToolTip, setTriggerToolTip] = useState({
        editTool: false,
        deleteTool: false,
        hideTool: false,
    })
    const drawerWidth =  240;
    const drawerList = [
        {
            "name": "Search",
            "icon": faMagnifyingGlass,
        },

        {
            "name": "Add",
            "icon": faPlus,
        },
        
        {
            "name": "Organize",
            "icon": faGrip,
        },
    ]

    //function that activates the active dashboard component
    function handleActiveBoard(name) {
        setActiveDashboard(name);
    }

    async function handleLogoutButton() {
        await axios.get(`${baseURL}/auth/logout`, {
            headers: {},
            withCredentials: true,
        })

        from = location.state?.from?.pathname || `/restaurants/menus/admin/login`
        navigate(from, {replace: true});
    }

    useEffect(() => {
        //assign a template to the restaurant based on its name
        // if(restaurantName == "white-coffee-spot") {
        //     setTemplate('template-1');
        // }
        // if(restaurantName == "testMenus") {
        //     setTemplate('template-2')
        // }

        //IMPORTANT: "THIS SHOULD BE DYNAMIC FOR SCALING UP"
        switch(restaurantName) {

            case "testMenus":
                setTemplate('template-2')
            break;

            case "white-coffee-spot":
                setTemplate('template-1')
            break;

            case "habra":
                setTemplate('template-1')
            break;

            case "lunchroom":
                setTemplate('template-1')
            break;

            case "five-am":
                setTemplate('template-1')
            break;

            case "baron":
                setTemplate("template-1")
            break;

            case "sek":
                setTemplate("template-3")
        }
    }, [])

    return (
        <DashboardPageStyled>
            <DrawerContainerStyled>
               <Drawer
                sx = {{
                    width: drawerWidth,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        boxSizing: 'border-box',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        
                    },
                }}
                variant = "permanent"
                anchor = "left"
               >
                    <List>
                       {drawerList.map(({name, icon}, index) => {
                        return (
                            <ListItem key = {name} disablePadding>
                                <ListItemButton onClick = { () => handleActiveBoard(name)}>
                                    <ListItemIcon>
                                        <FontAwesomeIcon icon = {icon} style = {{fontSize: "20px", padding: "0px"}}/>
                                    </ListItemIcon>
                                    <ListItemText primary = {name}/>
                                </ListItemButton>
                            </ListItem>
                        )
                       })}
                    </List> 
                    <ThemeProvider theme = {GeneralButtonStyled}>
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '100%',
                                marginBottom: '10px'
                            }}
                        >
                            <Button
                                variant="contained"
                                style={{width: "60%"}}
                                onClick = {handleLogoutButton}
                            >
                                LOGOUT
                            </Button>
                        </Box>
                    </ThemeProvider>
               </Drawer>
            </DrawerContainerStyled>
            <MainContainerStyled>
                {/* trigger Dashboard here*/}
                { activeDashboard == "Search" && 
                    <SearchDashboard 
                        url = {url} //remove this later (use the one in general functions)
                        restaurantName = {restaurantName}
                        activeDashboard = {activeDashboard}
                        triggerToolTip = {triggerToolTip} //only for search, edit and organize
                        setTriggerToolTip = {setTriggerToolTip} //only for search, edit and organize
                    />}
                { activeDashboard == "Add" && 
                    <AddDashboard
                       restaurantName = {restaurantName}
                       template = {template}
                       activeDashboard = {activeDashboard}
                    />}
                { activeDashboard == "Organize" && <OrganizeDashboard/>}
            </MainContainerStyled>
        </DashboardPageStyled>
    )
}


const DashboardPageStyled = styled.div`
    position: relative;
    width: 100vw;
    height: 100vh;
    display: flex;
`

const DrawerContainerStyled =styled.div`
    position: relative;
`

const MainContainerStyled =styled.div`
    position: relative;
    width: 100%;
    padding: 25px;
`

/* Category Flex Styles go here */




export default RestaurantsDashboard;